import { createSlice } from '@reduxjs/toolkit'

const defaultState = {
  primaryLogo: null,
  secondaryLogo: null,
}

const getInitialState = key => {
  if (window) {
    const config = window[key] || {}

    const initialState = {
      ...defaultState,
      ...config,
    }

    return initialState
  }

  return defaultState
}

export const initialState = getInitialState('whiteLabelConfig')

export const whiteLabelSettingsSliceConfig = {
  name: "whiteLabelSettings",
  initialState: initialState,
  reducers: {},
}

const whiteLabelSettingsSlice = createSlice(whiteLabelSettingsSliceConfig)
export const {
  actions: whiteLabelSettingsActions,
  reducer: whiteLabelSettingsReducer,
} = whiteLabelSettingsSlice
